// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"2ebba6a7","618":"0b0d7a7e","720":"10eeb882","741":"ea20d8ef","908":"d9580db6","996":"cfbb9e06"}[chunkId] + ".chunk.js";
};